import { render, staticRenderFns } from "./SaveCreditCustomer.vue?vue&type=template&id=5f6aa2b7&scoped=true&"
import script from "./SaveCreditCustomer.vue?vue&type=script&lang=js&"
export * from "./SaveCreditCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6aa2b7",
  null
  
)

export default component.exports